import { ApqModel } from "../../domain/ApqModel";
import { SectionProps } from "./SectionProps";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { Select } from "@ofqual/portal-components/components/Select";
import { Controller } from "react-hook-form";
import { Grid } from "@material-ui/core";
import { fieldLabelsOfq } from "../sections/fieldLabels";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import {
  cachedApqFitForPurposeService,
} from "../../services";

export const AssessmentPlanRecommendations: React.FC<SectionProps<ApqModel>> = ({
  control,
  errors,
  disabled,
  user: { token },
  item,
}) => {

  const [apqFitForPurposeLookups] = useLookup({
    service: cachedApqFitForPurposeService,
    id: "id",
    label: "value",
  });

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="shortTermSolution"
          as={
            <TextField
              multiline
              label={fieldLabelsOfq.proprosedShortTermSolution}
              disabled={disabled}
              data-test="shortTermSolution-field"
            ></TextField>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="longTermSolution"
          as={
            <TextField
              multiline
              label={fieldLabelsOfq.proposedlongTermSolution}
              disabled={disabled}
              data-test="longTermSolution-field"
            ></TextField>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="fitForPurposeCriteriaId"
          as={
            <Select
              label={fieldLabelsOfq.fitForPurpose}
              disabled={disabled}
              datatest="fitForPurposeId-field"
            >
              {apqFitForPurposeLookups}
            </Select>
          }
        />
      </Grid>
    </Grid>
  );
};
